// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"369f2726","484":"b4e7eca7","694":"d231ecc8"}[chunkId] + ".chunk.css";
};